import { ThunkDispatch } from 'store/store';
import { AnyAction } from 'redux';
import { WidgetSetConfigAction } from 'widgets/store/configuration/actions';
import { BlotterConfiguration } from 'widgets/blotter/store/configuration/BlotterConfiguration';
import { WidgetActionType } from 'widgets/store/actions';
import { WidgetType } from 'widgets/WidgetType';
import Services from 'store/Services';
import { blotterPortfolioMiddleware } from 'widgets/blotter/store/portfolio/middleware';
import { blotterFilteredOrdersMiddleware } from 'widgets/blotter/store/filteredOrders/middleware';

export const blotterMiddleware = (services: Services) => [
    updateOrdersStreamOnBlotterConfigChangedMiddleware(services),
    ...blotterPortfolioMiddleware(services),
    ...blotterFilteredOrdersMiddleware(services),
];

export function updateOrdersStreamOnBlotterConfigChangedMiddleware(
    services: Services
) {
    const { loggingService, ordersStreamingService } = services;

    return () => (next: ThunkDispatch<AnyAction>) => (action: AnyAction) => {
        // update the state
        next(action);

        const setConfigAction =
            action as WidgetSetConfigAction<BlotterConfiguration>;

        if (
            setConfigAction.type === WidgetActionType.WIDGET_SET_CONFIG &&
            setConfigAction.payload?.widgetType === WidgetType.BLOTTER
        ) {
            ordersStreamingService.startOrUpdateOrdersStream();

            loggingService.debug(
                'store|updateOrdersStreamOnBlotterConfigChangedMiddleware',
                `Starting/Updating orders stream for ${action.type}`,
                action
            );
        }
    };
}
